/**
 * @fileoverview Vuex mutations for generative AI state management.
 *
 * @module store/modules/genai/mutations
 *
 * Handles synchronous state updates for:
 * - GenAI modules and functions
 * - Uploaded documents and loading states
 * - Articles, websites, and personas
 * - Query results and search documents
 */

import Vue from "vue";
import { MutationTree } from "vuex/types";

import { GenAIState } from "./types";

const mutations: MutationTree<GenAIState> = {
  /**
   * Sets the available GenAI modules.
   *
   * @param payload - Modules configuration object
   */
  GENAI_SET_MODULES: (state, payload) => {
    Vue.set(state, "modules", payload);
  },
  GENAI_SET_SELECTED_MODULE_ID: (state, payload) => {
    // TODO
  },
  GENAI_SET_SELECTED_FUNCTION_ID: (state, payload) => {
    // TODO
  },
  /**
   * Updates a specific GenAI module by ID.
   *
   * @param payload - Module object with id property
   */
  SET_GENAI_MODULE: (state, payload) => {
    Vue.set(state.genaiModules, payload.id, payload);
  },
  GENAI_SET_DOCUMENTS: (state, payload) => {
    Vue.set(state, "genai_query_documents", payload);
  },
  GENAI_SET_QUERY_RESULT: (state, payload) => {
    Vue.set(state, "genai_query_result", payload);
  },
  /**
   * Sets the list of uploaded documents.
   *
   * @param payload - Documents array or object with rows/count
   */
  GENAI_SET_UPLOADED_DOCUMENTS: (state, payload) => {
    Vue.set(state, "genai_uploaded_documents", payload);
  },
  /**
   * Sets loading state for document operations.
   *
   * @param payload - Boolean indicating if documents are loading
   */
  SET_LOADING_DOCUMENTS: (state, payload) => {
    Vue.set(state, "isGettingDocuments", payload);
  },
  /**
   * Sets the list of knowledge base articles.
   *
   * @param payload - Articles array
   */
  GENAI_SET_ARTICLES: (state, payload) => {
    Vue.set(state, "genai_articles", payload);
  },
  /**
   * Sets the list of scraped websites.
   *
   * @param payload - Websites array
   */
  GENAI_SET_WEBSITES: (state, payload) => {
    Vue.set(state, "genai_websites", payload);
  },
  /**
   * Sets the list of AI personas.
   *
   * @param payload - Personas array
   */
  GENAI_SET_PERSONAS: (state, payload) => {
    Vue.set(state, "genai_personas", payload);
  },
};

export default mutations;
